import { t } from '@hefe/i18n';
import { API, KnowledgeBaseApi } from '@hefe/store';
import { AutoComplete, Col, Divider, Input, Row, Typography } from 'antd';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import HighlightArticlesListComponent from '../../components/highlight-articles-list/highlight-articles-list.component';
import KnowledgeBaseLayout from '../../layout/knowledge-base.layout';

export default function KnowledgeBaseHomePage() {
  const navigate = useNavigate();

  const { data: latestArticles = [], isFetching: isFetchingLatest } =
    KnowledgeBaseApi.useFetchLatestArticlesQuery();

  const { data: topArticles = [], isFetching: isFetchingTop } =
    KnowledgeBaseApi.useFetchTopArticlesQuery();

  const [searchText, setSearchText] = useState('');
  const [searchResults, setSearchResults] = useState<string[]>([]);
  const [autocompleteDropdownOpen, setAutocompleteDropdownOpen] =
    useState(false);

  useEffect(() => {
    const getData = setTimeout(() => {
      handleSearchSuggestions(searchText);
    }, 500);

    return () => clearTimeout(getData);
  }, [searchText]);

  const handleSearchSuggestions = (value: string) => {
    if (!value || value.length < 3) {
      return;
    }

    // check if valiue is in search results
    if (searchResults.includes(value)) {
      return;
    }

    API.knowledgeBase()
      .getSearchSuggestions(value)
      .then((res) => {
        setSearchResults(res.data);
      });
  };

  const handleSelect = (value: string) => {
    setSearchText(value);
  };

  const handleSearch = (value: string) => {
    if (!autocompleteDropdownOpen) {
      navigate(`/knowledge-base/search?q=${value}`);
    }
  };

  return (
    <KnowledgeBaseLayout>
      <Row justify="center" align="middle" style={{ minHeight: 400 }}>
        <Col span={12} xs={24} sm={18} style={{ textAlign: 'center' }}>
          <Typography.Title level={1}>
            {t('knowledge_base.search.question')}
          </Typography.Title>
          <Typography.Paragraph>
            {t('knowledge_base.search.description')}
          </Typography.Paragraph>
          <AutoComplete
            style={{ width: '100%' }}
            size="large"
            onSelect={handleSelect}
            onDropdownVisibleChange={(open) =>
              setAutocompleteDropdownOpen(open)
            }
            options={searchResults.map((item) => ({
              label: item,
              value: item,
            }))}
          >
            <Input.Search
              size="large"
              placeholder={t('knowledge_base.search.placeholder')}
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              onSearch={handleSearch}
            />
          </AutoComplete>
        </Col>
      </Row>
      <Divider />
      <Row>
        <Col xs={24} sm={12}>
          <HighlightArticlesListComponent
            title={t('knowledge_base.articles.most_read')}
            articles={topArticles}
            fetching={isFetchingTop}
          />
        </Col>
        <Col xs={24} sm={12}>
          <HighlightArticlesListComponent
            title={t('knowledge_base.articles.latest')}
            articles={latestArticles}
            fetching={isFetchingLatest}
          />
        </Col>
      </Row>
    </KnowledgeBaseLayout>
  );
}
